export const convertToJapaneseCalendar　= (WesternDateTime: string | null): string =>  {
  if(!WesternDateTime){
    return '';
  }

  const westernDt = new Date(WesternDateTime);

  for (let i = jaCalender.length - 1; i >= 0; i--) {
      const t = new Date(jaCalender[i]['start']);
      // 元号の範囲に入っている場合
      if(westernDt >= t) {
        // 和暦に変換して返す
        const japaneseDate = westernDt.getFullYear() + '年(' + jaCalender[i]['era'] + (westernDt.getFullYear() - t.getFullYear() + 1) + '年)' + (westernDt.getMonth() + 1) + '月' + westernDt.getDate() + '日';
        if(WesternDateTime.length <= 10){
            return japaneseDate
        }else{
            return japaneseDate + ' ' + toDoubleDigits(String(westernDt.getHours())) + ':' + toDoubleDigits(String(westernDt.getMinutes())) + ':' + toDoubleDigits(String(westernDt.getSeconds()));
        }
      }
  }
  return '(和暦変換不可)' + WesternDateTime;
}

// 1桁の数字を0埋めで2桁にする
const toDoubleDigits = (num: string) =>{
    if (num.length === 1) {
      num = '0' + num;
    }
   return num;
  };

// 元号の情報
const jaCalender =  [
    {
        era: '明治',
        start: '1868/1/25'
    },
    {
        era: '大正',
        start: '1912/7/30'
    },
    {
        era: '昭和',
        start: '1926/12/25'
    },
    {
        era: '平成',
        start: '1989/1/8'
    },
    {
        era: '令和',
        start: '2019/5/1'
    },
]
